import { render } from "./MainTable.vue?vue&type=template&id=fd101a76"
import script from "./MainTable.vue?vue&type=script&lang=js"
export * from "./MainTable.vue?vue&type=script&lang=js"

import "./MainTable.vue?vue&type=style&index=0&id=fd101a76&lang=css"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/price-managment/MainTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd101a76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd101a76', __exports__)) {
    console.log('reload')
    api.reload('fd101a76', __exports__)
  }
  
  module.hot.accept("./MainTable.vue?vue&type=template&id=fd101a76", () => {
    console.log('re-render')
    api.rerender('fd101a76', render)
  })

}


export default __exports__